var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15822 6.84209C8.54389 6.22802 7.71084 5.88306 6.84222 5.88306C5.97361 5.88306 5.14055 6.22802 4.52622 6.84209L2.20947 9.15809C1.59513 9.77243 1.25 10.6057 1.25 11.4745C1.25 12.3433 1.59513 13.1765 2.20947 13.7908C2.82381 14.4052 3.65704 14.7503 4.52585 14.7503C5.39466 14.7503 6.22788 14.4052 6.84222 13.7908L8.00022 12.6328",
    stroke: "#7E47FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84229 9.15798C7.45662 9.77205 8.28967 10.117 9.15828 10.117C10.0269 10.117 10.86 9.77205 11.4743 9.15798L13.791 6.84198C14.4054 6.22764 14.7505 5.39441 14.7505 4.5256C14.7505 3.6568 14.4054 2.82357 13.791 2.20923C13.1767 1.59489 12.3435 1.24976 11.4747 1.24976C10.6059 1.24976 9.77263 1.59489 9.15828 2.20923L8.00028 3.36723",
    stroke: "#7E47FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.1e903eff5050cca36ae44d37943ad8ce.svg";
export { ForwardRef as ReactComponent };